import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";

import {
  labelShare,
  labelInfo,
  labelDelete,
  buttonDelete,
  buttonLeave,
  labelLeaveProject,
  modalConfirmDeleteProjectSubtitlePart1,
  modalConfirmDeleteProjectSubtitlePart2,
  modalConfirmDeleteProjectTitle,
  modalConfirmLeaveProjectSubTitlePart1,
  modalConfirmLeaveProjectSubTitlePart2,
  modalConfirmLeaveProjectTitle,
  snackbarProjectDeletedSubTitlePart1,
  snackbarProjectDeletedSubTitlePart2,
  snackbarProjectDeletedTitle,
  snackbarProjectAbandonedSubTitlePart1,
  snackbarProjectAbandonedSubTitlePart2,
  snackbarProjectAbandonedTitle,
} from "_constants";
import { useRef, useState } from "react";
import { Menu } from "primereact/menu";
import { ButtonSetProjectPreferred } from "components/buttons";
import { useConfirmDialogExit } from "hooks";
import { Project } from "interfaces";
import { getUserId } from "utils";
import { deleteProject, getDetailProject, leaveProject } from "services";
import { useSnackbar } from "providers/SnackbarProvider";
import { useAppDispatch } from "store/store";
import { ModalShareProject } from "../../projectsPage/components/card/components/actions";
import {
  resetProjectsState,
  setCurrentProject,
} from "store/slicer/GestioneProjectsSlice";
import { DetailPanelActions } from "components/DetailPanel/DetailPanelActions";
import { ProjectDetailPanelHeader } from "../../projectsPage/components/detailPanel/ProjectDetailPanelHeader";
import { DetailPanelSourcesContainer } from "../../projectsPage/components/detailPanel/DetailPanelSourcesContainer";
import { DetailPanelUserslist } from "../../projectsPage/components/detailPanel/DetailPanelUsersList";
import { useDetailPanelProvider } from "providers/DetailPanelProvider";
import { useNavigate } from "react-router-dom";

export const ActionsProject = ({
  project,
  projectId,
}: {
  project: Project;
  projectId: string;
}) => {
  const navigate = useNavigate();
  const menu = useRef<Menu>(null);
  const [showShareModal, setShowShareModal] = useState(false);
  const dispatch = useAppDispatch();
  const { showConfirmDialogDelete } = useConfirmDialogExit();
  const { showSnackbar } = useSnackbar();
  const { showPanel, hidePanel } = useDetailPanelProvider();

  const getProjectDetail = () => {
    if (projectId) {
      getDetailProject(projectId)
        .then((response) => {
          dispatch(setCurrentProject(response.data as any));
          showDetailPanel(response.data);
        })
        .catch((_) => {});
    }
  };
  const showDetailPanel = (projectDetail: Project) => {
    showPanel({
      icons: (
        <>
          {project?.id && (
            <ButtonSetProjectPreferred
              projectId={projectId}
              isPreferred={projectDetail.isPreferred}
              customClass="width-px-28 height-px-28"
            />
          )}
          <DetailPanelActions
            items={[
              ...(project.createdById === getUserId()
                ? [
                    {
                      label: labelShare,
                      icon: PrimeIcons.SHARE_ALT,
                      command: () => {
                        openShareModal();
                      },
                    },
                  ]
                : []),
              {
                label:
                  project.createdById === getUserId()
                    ? labelDelete
                    : labelLeaveProject,
                icon: PrimeIcons.TRASH,
                className: "delete-color",
                command: () => {
                  openDeleteModal();
                },
              },
            ]}
          />
        </>
      ),
      header: <ProjectDetailPanelHeader />,
      body: (
        <>
          <DetailPanelSourcesContainer
            codesTotal={projectDetail.codesSourceTotal ?? 0}
            archivesTotal={projectDetail.archiveSourceTotal ?? 0}
            privatesTotal={projectDetail.privateSourceTotal ?? 0}
          />
          <DetailPanelUserslist
            usersList={projectDetail.users ?? []}
            project={project}
            projectId={projectId}
          />
        </>
      ),
    });
  };

  const confirmDeleteProject = () => {
    if (projectId) {
      deleteProject(projectId)
        .then((_) => {
          showSnackbar({
            severity: "success",
            summary: snackbarProjectDeletedTitle,
            detail: `${snackbarProjectDeletedSubTitlePart1}"${project.name}" ${snackbarProjectDeletedSubTitlePart2}`,
            life: 5000,
          });
          dispatch(resetProjectsState());
          hidePanel();
          navigate("/bo");
        })
        .catch((_) => {});
    }
  };

  const confirmLeaveProoject = () => {
    if (projectId) {
      leaveProject(projectId)
        .then((_) => {
          showSnackbar({
            severity: "success",
            summary: snackbarProjectAbandonedTitle,
            detail: `${snackbarProjectAbandonedSubTitlePart1}"${project.name}" ${snackbarProjectAbandonedSubTitlePart2}`,
            life: 5000,
          });
          dispatch(resetProjectsState());
          navigate("/bo");
        })
        .catch((_) => {});
    }
  };

  const openDeleteModal = () => {
    showConfirmDialogDelete({
      title:
        project.createdById === getUserId()
          ? modalConfirmDeleteProjectTitle
          : modalConfirmLeaveProjectTitle,
      subtitle:
        project.createdById === getUserId()
          ? `${modalConfirmDeleteProjectSubtitlePart1}<b class="capitalize">${project.name}</b>${modalConfirmDeleteProjectSubtitlePart2}`
          : `${modalConfirmLeaveProjectSubTitlePart1}<b class="capitalize">${project.name}</b>${modalConfirmLeaveProjectSubTitlePart2}`,
      rejectButtonLabel:
        project.createdById === getUserId() ? buttonDelete : buttonLeave,
      rejectCallback:
        project.createdById === getUserId()
          ? confirmDeleteProject
          : confirmLeaveProoject,
      icon: PrimeIcons.USER_MINUS,
    });
  };

  const openShareModal = () => {
    setShowShareModal(true);
  };

  const items = [
    ...(project.createdById === getUserId()
      ? [
          {
            label: labelShare,
            icon: PrimeIcons.SHARE_ALT,
            command: () => {
              openShareModal();
            },
          },
        ]
      : []),
    {
      label: labelInfo,
      icon: PrimeIcons.INFO_CIRCLE,
      command: () => {
        getProjectDetail();
      },
    },
    {
      separator: true,
    },
    {
      label:
        project.createdById === getUserId() ? labelDelete : labelLeaveProject,
      icon: PrimeIcons.TRASH,
      className: "delete-color",
      command: () => {
        openDeleteModal();
      },
    },
  ];
  return (
    <>
      <div className="actions">
        {projectId && (
          <ButtonSetProjectPreferred
            projectId={projectId}
            isPreferred={project.isPreferred}
          />
        )}
        <Menu model={items} popup ref={menu} className="tiered-menu-custom" />
        <Button
          icon={PrimeIcons.ELLIPSIS_V}
          text
          className="meatball"
          onClick={(e) => menu.current!.toggle(e)}
        />
      </div>
      {showShareModal && (
        <ModalShareProject
          project={project}
          showDialog={showShareModal}
          projectId={projectId}
          onClose={() => setShowShareModal(false)}
        />
      )}
    </>
  );
};
